import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Label, Message, Modal, Segment,Divider} from 'semantic-ui-react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import {availLeaveOnDate, cancelLeave, getLeaveList} from '../../../data/user_api';
import {CLERK_API_URL, LEAVE_APPLICATION_URL} from '../../../constants/api_routes';
import Loader from '../../universal/loader';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));


const customSlotPropGetter = (date) => {
    if (date < moment().add(+4, 'day').toDate()) {
        if (date === moment().toDate()) {
            return {
                className: 'today'
            }
        }
        return {
            className: 'unallowed-day'
        }
    } else return {className: 'allowed-day'}
};


class AvailLeave extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: moment().add(+7, 'day').format("YYYY-MM-DD"),
            selectedTimeOption: undefined,
            leaveStartTime: "00:00",
            leaveEndTime: "23:59",
            clerkId: this.props.clerkId,
            disableSubmit: true,
            isLoading: true,
            myEventsList: [],
            message: undefined,
            loading:false
        }
    }

    componentWillMount() {
        this.fetchLeaves().then(() => {
        });
    };

    fetchLeaves = async () => {
        const {leaves} = await getLeaveList(CLERK_API_URL, this.state.clerkId);
        let myEventsList = [];
        if (leaves) {
            for (let i = 0; i < leaves.length; i++) {
                const startTime = leaves[i].leave['leave_date'] + " " + leaves[i].leave['start_time'];
                const endTime = leaves[i].leave['leave_date'] + " " + leaves[i].leave['end_time'];
                let obj = {
                    id: leaves[i].leave.id,
                    title: moment(leaves[i].leave['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " - " + moment(leaves[i].leave['end_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm"),
                    start: moment(startTime, 'YYYY-MM-DD HH:mm:ss Z').toDate(),
                    end: moment(endTime, 'YYYY-MM-DD HH:mm:ss Z').toDate(),
                    leaveDescription: leaves[i].leave['description'],
                };
                myEventsList.push(obj);
            }
            this.setState({myEventsList: myEventsList});
        }
        this.setState({isLoading: false})
    };

    onStartChange = (value) => {
        this.setState({leaveStartTime: moment(value).format("HH:mm")});
    };
    onEndChange = (value) => {
        this.setState({leaveEndTime: moment(value).format("HH:mm")});

    };
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({error: undefined, loading:true})
        const startTime = this.state.selectedDate + " " + this.state.leaveStartTime.toString();
        const endTime = this.state.selectedDate + " " + this.state.leaveEndTime.toString();
        let formData = new FormData(e.target);
        formData.append("clerk_profile_id", this.state.clerkId.toString());
        formData.append("start_time", startTime);
        formData.append("end_time", endTime);
        if (this.state.selectedTimeOption === 1) {
            formData.append("is_available", 'true');
        } else {
            formData.append("is_available", 'false');
        }
        if(!this.state.selectedTimeOption){
            this.setState({disableSubmit:true,loading:false,error: "Some fields are empty"});
            return;
        }
        if (this.state.clerkId && this.state.selectedDate && this.state.leaveStartTime && this.state.leaveEndTime) {
            const result = await availLeaveOnDate(LEAVE_APPLICATION_URL, this.state.clerkId, formData);
            if (result.success) {
                this.setState({isLoading: true});
                this.fetchLeaves().then(() => {
                    this.setState({isLoading: false, message: "Successfully Recorded your leave into the calender",loading:false})
                });
            } else {
                this.setState({error: "You already have an Inspection or PV assigned on this date, please contact the office to get them reassigned before booking leave",loading:false})
            }
        } else {
            this.setState({error: "Some of the fields are empty",loading:false})
        }

    };

    cancelLeave = (leaveId) => {
        this.setState({cancelling:true});
        cancelLeave(LEAVE_APPLICATION_URL,leaveId).then((response) => {
            if (response.success) {
                this.setState({isLoading: true,showLeaveDelete:false});
                this.fetchLeaves().then(() => {
                    this.setState({isLoading: false});
                });
            }
            this.setState({cancelling:false});
        });
    };

    render() {
        const leaveType = [
            {key: 0, text: 'Partially Available', value: 1},
            {key: 1, text: 'Partially Un-Available', value: 2},
            {key: 2, text: 'Full Day Un-Available', value: 3}
        ];

        const timeFormat = 'h:mm A';
        return (<div className="additional-pad pad-top">
            <Header content="Update Availability" textAlign="center" size="large"/>
            <Grid stackable style={{padding: '0% 3% 5% 3%'}}>
                <Grid.Column width={11}>
                    {this.state.isLoading ? <Loader/> : <BigCalendar
                        selectable
                        events={this.state.myEventsList}
                        scrollToTime={moment().toDate()}
                        defaultDate={moment().toDate()}
                        onSelectEvent={(event) => {
                            this.setState({selectedLeave:event});
                                this.setState({showLeaveDelete:true});
                            this.setState({selectedDate: moment().add(+7, 'day').format("YYYY-MM-DD")})
                        }}
                        min={moment().add(+4, 'day').startOf('day').toDate()}
                        max={moment().add(+2, 'year').startOf('day').toDate()}
                        onSelectSlot={(slotInfo) => {
                            slotInfo.start > moment().add(+4, 'day') ? this.setState({
                                selectedDate: moment(slotInfo.start, "LLLLL").format("YYYY-MM-DD"),
                                disableSubmit: false
                            }) : this.setState({selectedDate: undefined, disableSubmit: true})
                        }}
                        dayPropGetter={customSlotPropGetter}
                        slotPropGetter={customSlotPropGetter}
                    />}
                </Grid.Column>
                <Grid.Column width={5}>
                    <Header content="Selections"/>
                    <div><span style={{fontSize: '1.2em'}}>Avail Leave on : </span><span style={{
                        fontSize: '1.2em',
                        fontWeight: '700',
                        color: '#000'
                    }}>{moment(this.state.selectedDate, 'YYYY-MM-DD') > moment().add(+4, 'day') ? this.state.selectedDate : "Invalid Selection/Choose Another date"}</span>
                    </div>
                    <Segment>
                        <Form onSubmit={this.handleSubmit}>

                            <Form.Dropdown
                                label='Record Leave As'
                                selection
                                wrapSelection={false}
                                options={leaveType}
                                placeholder='Select Type'
                                onChange={(e, option) => {
                                    this.setState({selectedTimeOption: option.value});
                                    if (option.value === 3) {
                                        this.setState({leaveStartTime: "00:00", leaveEndTime: "23:59"});
                                    }
                                }}
                            />
                            {this.state.selectedTimeOption !== 3 && this.state.selectedTimeOption && <div>
                                <Form.Group inline>
                                    <Label content='From :'/>
                                    <TimePicker
                                        showSecond={false}
                                        showMinute={false}
                                        placeholder='12 AM'
                                        defaultValue={moment().hour(0).minute(0)}
                                        className="time-width"
                                        onChange={this.onStartChange}
                                        format={timeFormat}
                                        use12Hours
                                        minuteStep={15}
                                        inputReadOnly
                                    /><span>--</span>
                                    <Label content='To :'/>
                                    <TimePicker
                                        showSecond={false}
                                        showMinute={false}
                                        defaultValue={moment().hour(0).minute(0)}
                                        placeholder='12 PM'
                                        className="time-width"
                                        onChange={this.onEndChange}
                                        format={timeFormat}
                                        use12Hours
                                        minuteStep={15}
                                        inputReadOnly
                                    />
                                </Form.Group>
                            </div>}
                            <Form.TextArea name='description' label="Add Note"
                                           placeholder="Would you like to specify Reason for leave?"/>
                            <Button disabled={this.state.disableSubmit || this.state.loading} loading={this.state.loading} primary content='Record Time'/>
                        </Form>
                        {this.state.message && <Message positive content={this.state.message} onDismiss={() => {
                            this.setState({message: undefined})
                        }}/>}
                        {this.state.error && <Message error content={this.state.error} onDismiss={() => {
                            this.setState({error: undefined})
                        }}/>}
                    </Segment>
                </Grid.Column>
            </Grid>

            <Modal size="tiny" open={this.state.showLeaveDelete} onClose={(e) => {
                this.setState({showLeaveDelete: false});
            }}>
                <Modal.Content>
                    <div className="modal-close-button">
                        <Button basic icon negative onClick={(e) => {
                            this.setState({showLeaveDelete: false});
                        }}><Icon name="close"/></Button>
                    </div>
                    <Modal.Description>
                        <Header content="Cancel Leave" size="large" />
                        <Divider section />
                        {this.state.selectedLeave && <div>
                            <dl>
                                <dt>Leave Start Time:</dt>
                                <dd>{moment(this.state.selectedLeave.start).format("DD-MM-YYYY HH:mm")}</dd>
                                <dt>Leave End Time</dt>
                                <dd>{moment(this.state.selectedLeave.end).format("DD-MM-YYYY HH:mm")}</dd>
                            </dl>
                            <p className="format-bold">Reason Specified:</p>
                            <p>{this.state.selectedLeave.leaveDescription.length > 2 ?this.state.selectedLeave.leaveDescription:"No Reason Specified" }</p>
                        </div>}
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={()=>{this.setState({showLeaveDelete: false})}} disabled={this.state.cancelling}/>
                    <Button content="Mark as Available" primary onClick={() => {this.cancelLeave(this.state.selectedLeave.id)}} disabled={this.state.cancelling} loading={this.state.cancelling}/>
                </Modal.Actions>
            </Modal>
        </div>);
    }
}

export default AvailLeave;


// WEBPACK FOOTER //
// ./src/views/user/clerk/avail_leave.js